import { render, staticRenderFns } from "./LoginMobile.vue?vue&type=template&id=c564b2b0"
import script from "./LoginMobile.vue?vue&type=script&lang=js"
export * from "./LoginMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports